/* ===============================================================
   SALVE brand layer.
   Progressive: with JavaScript off the page is the page it was,
   minus the motion.
   =============================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NS = 'http://www.w3.org/2000/svg';

  function mk(tag, attrs) {
    var el = document.createElementNS(NS, tag);
    for (var k in attrs) el.setAttribute(k, attrs[k]);
    return el;
  }

  function observe(els, cb, margin) {
    if (!('IntersectionObserver' in window)) { els.forEach(cb); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { cb(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: margin || '0px 0px -8% 0px', threshold: 0.01 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* 1. Figures draw themselves in, stroke by stroke.
     Drawing starts well before the plate reaches the viewport so a
     fast scroll never lands on an empty box. */
  function prepFigure(fig) {
    var paths = fig.querySelectorAll('.fig__p');
    var last = 0;
    Array.prototype.forEach.call(paths, function (p, i) {
      var len = 1200;
      try { len = Math.ceil(p.getTotalLength()) || 1200; } catch (e) {}
      var d = Math.min(i * 0.06, 0.3);
      p.style.setProperty('--len', len);
      p.style.setProperty('--d', d.toFixed(2) + 's');
      last = d;
    });
    var dots = fig.querySelectorAll('.fig__dot');
    Array.prototype.forEach.call(dots, function (d, i) {
      d.style.setProperty('--dd', (0.42 + last + i * 0.04).toFixed(2) + 's');
    });
  }

  var figures = [].slice.call(document.querySelectorAll('[data-figure]'));
  if (figures.length) {
    if (reduced) {
      figures.forEach(function (f) { f.classList.add('is-drawn'); });
    } else {
      figures.forEach(prepFigure);
      observe(figures, function (f) { f.classList.add('is-drawn'); }, '320px 0px 320px 0px');
    }
  }

  /* 2. Hairlines between sections become a stitched seam. */
  function seamFor(el) {
    var s = mk('svg', {
      'class': 'seam', viewBox: '0 0 1200 9',
      preserveAspectRatio: 'none', 'aria-hidden': 'true', focusable: 'false'
    });
    s.appendChild(mk('path', { 'class': 'seam__line', d: 'M0 4.5 H1200' }));
    return s;
  }

  var ruled = [].slice.call(
    document.querySelectorAll('.salve-page section[style*="border-top"]')
  ).filter(function (el) { return el.offsetParent !== null; });

  ruled.forEach(function (sec) {
    sec.style.borderTop = '0';
    var s = seamFor(sec);
    sec.insertBefore(s, sec.firstChild);
    s.style.marginBottom = '26px';
  });
  observe([].slice.call(document.querySelectorAll('.seam')), function (s) {
    s.classList.add('is-in');
  });

  /* 3. Section headings rise from behind the seam. */
  if (!reduced) {
    var heads = [].slice.call(document.querySelectorAll('.salve-page .s-h2'))
      .filter(function (h) { return h.children.length === 0 || h.querySelector('br,span,em,b'); });
    heads.forEach(function (h) {
      if (h.dataset.risen) return;
      h.dataset.risen = '1';
      var inner = document.createElement('span');
      inner.innerHTML = h.innerHTML;
      h.innerHTML = '';
      h.appendChild(inner);
      h.classList.add('rise');
      h.style.paddingBottom = '0.12em';
    });
    observe(heads, function (h) { h.classList.add('is-in'); });
  }

  /* 4. Catalogue cards: category accent, and the fit line written
     in chalk on the plate rather than stacked under it.
     Touch devices have no hover, so the chalk is never promoted
     there and the note stays where it was. */
  var canHover = window.matchMedia('(hover: hover)').matches;
  var cards = [].slice.call(document.querySelectorAll('.cl-card'));
  cards.forEach(function (card) {
    var type = card.getAttribute('data-tabitem');
    if (type) card.classList.add('cat-' + type);
    if (!canHover) return;
    var note = card.querySelector('.cl-card__note');
    var plate = card.querySelector('.plate');
    if (note && plate && note.textContent.trim() && !plate.querySelector('.chalk')) {
      var c = document.createElement('span');
      c.className = 'chalk';
      c.setAttribute('aria-hidden', 'true');
      c.textContent = note.textContent.trim();
      plate.appendChild(c);
      card.classList.add('has-chalk');
    }
  });

  /* 5. The seal, set into the footer beside the wordmark. */
  function seal() {
    var s = mk('svg', {
      'class': 'seal', viewBox: '0 0 64 64', 'aria-hidden': 'true', focusable: 'false'
    });
    var ring = mk('g', { 'class': 'seal__ring' });
    ring.appendChild(mk('circle', { cx: 32, cy: 32, r: 29, fill: 'none', stroke: 'currentColor' }));
    for (var i = 0; i < 24; i++) {
      var a = (i / 24) * Math.PI * 2;
      var long = i % 6 === 0;
      var r1 = long ? 22.5 : 25.5;
      ring.appendChild(mk('line', {
        'class': 'seal__tick',
        x1: (32 + Math.cos(a) * r1).toFixed(2),
        y1: (32 + Math.sin(a) * r1).toFixed(2),
        x2: (32 + Math.cos(a) * 28).toFixed(2),
        y2: (32 + Math.sin(a) * 28).toFixed(2)
      }));
    }
    s.appendChild(ring);
    s.appendChild(mk('path', {
      'class': 'seal__s',
      d: 'M40 22 C40 17 24 16 24 23 C24 30 40 29 40 38 C40 46 23 45 23 40'
    }));
    return s;
  }

  var mark = document.querySelector('.s-foot__mark');
  if (mark && !document.querySelector('.s-foot .seal')) {
    var wrap = document.createElement('div');
    wrap.style.cssText = 'display:flex;align-items:center;gap:14px;margin-bottom:6px';
    mark.parentNode.insertBefore(wrap, mark);
    wrap.appendChild(seal());
    wrap.appendChild(mark);
  }

  /* 6. The rail reads as a tape measure: inches against scroll. */
  var read = document.querySelector('[data-railread]');
  if (read) {
    var scroller = document.querySelector('.page-wrapper');
    var host = (scroller && scroller.scrollHeight > scroller.clientHeight + 40)
      ? scroller : (document.scrollingElement || document.documentElement);
    var tick = false;
    var update = function () {
      tick = false;
      var top = host === document.scrollingElement ? window.pageYOffset : host.scrollTop;
      var max = Math.max(1, host.scrollHeight - host.clientHeight);
      read.textContent = (Math.min(1, top / max) * 36).toFixed(1) + '\"';
    };
    var q = function () { if (!tick) { tick = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', q, { passive: true });
    if (host !== document.scrollingElement) host.addEventListener('scroll', q, { passive: true });
    update();
  }
})();
